<template>
  <div class="case-file-upload">
    <div :id="uploadId" class="uploader uploader-warning"></div>
    <div v-for="(item, idx) in value" :key="uploadId + '-f-' + idx" class="file-row">
      <a class="file-name" :href="fileUrl(item)" target="_blank" :title="item.fileName || item.filePath">
        {{ item.fileName || item.filePath }}
      </a>
      <el-button-group style="margin-left: 8px">
        <el-tooltip content="预览" placement="top">
          <el-button type="success" icon="el-icon-view" size="mini" @click="preview(item)"></el-button>
        </el-tooltip>
        <el-tooltip content="前移" placement="top">
          <el-button
            type="primary"
            icon="el-icon-arrow-left"
            size="mini"
            :disabled="idx === 0"
            @click="move(idx)"
          ></el-button>
        </el-tooltip>
        <el-tooltip content="删除" placement="top">
          <el-button type="danger" icon="el-icon-delete" size="mini" @click="remove(idx)"></el-button>
        </el-tooltip>
      </el-button-group>
    </div>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";

export default {
  name: "CaseFileUpload",
  props: {
    value: { type: Array, default: () => [] },
    uploadId: { type: String, required: true },
    active: { type: Boolean, default: false },
    /** 支持图片+常见文档 */
    fileExts: {
      type: String,
      default: "jpg;jpeg;png;gif;bmp;webp;pdf;doc;docx;xls;xlsx;ppt;pptx;txt;zip;rar;7z"
    },
    btnText: { type: String, default: "上传图片/文档" }
  },
  data() {
    return {
      domain: url.getDomain(),
      uploaderInited: false
    };
  },
  watch: {
    active(val) {
      if (val) this.$nextTick(() => this.initUploader());
    },
    uploadId() {
      this.uploaderInited = false;
      if (this.active) this.$nextTick(() => this.initUploader());
    }
  },
  mounted() {
    if (this.active) this.$nextTick(() => this.initUploader());
  },
  methods: {
    fileUrl(item) {
      if (!item || !item.filePath) return "";
      return this.domain + item.filePath;
    },
    /** 取扩展名 */
    getExt(item) {
      var name = ((item && (item.fileName || item.filePath)) || "").toLowerCase();
      var i = name.lastIndexOf(".");
      return i >= 0 ? name.substring(i + 1) : "";
    },
    preview(item) {
      var file = this.fileUrl(item);
      if (!file) return;
      var ext = this.getExt(item);
      // pdf 浏览器可直接预览；word 用 Office 在线预览（需公网可访问的 https 地址）
      if (ext === "doc" || ext === "docx") {
        if (file.indexOf("https://") !== 0) {
          this.$message.warning("本地环境无法在线预览 Word，请下载查看或在正式环境预览");
          window.open(file, "_blank");
          return;
        }
        window.open(
          "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(file),
          "_blank"
        );
        return;
      }
      window.open(file, "_blank");
    },
    initUploader() {
      if (this.uploaderInited) return;
      var sel = "#" + this.uploadId;
      if ($(sel + " input").length > 0) {
        this.uploaderInited = true;
        return;
      }
      var _this = this;
      $(sel).uploader({
        url: url.getUpload(),
        fileExts: this.fileExts,
        text: this.btnText,
        more: true,
        auto: true,
        handleType: "0",
        isImg: false,
        onSuccess: function(data) {
          var list = (_this.value || []).slice();
          list.push({ filePath: data.relativeName, fileName: data.fileName || "" });
          _this.$emit("input", list);
        }
      });
      this.uploaderInited = true;
    },
    move(idx) {
      if (idx <= 0) return;
      var list = this.value.slice();
      var temp = list[idx];
      list[idx] = list[idx - 1];
      list[idx - 1] = temp;
      this.$emit("input", list);
    },
    remove(idx) {
      var list = this.value.slice();
      list.splice(idx, 1);
      this.$emit("input", list);
    }
  }
};
</script>

<style scoped>
.file-row {
  margin-top: 8px;
  display: flex;
  align-items: center;
}
.file-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #409eff;
}
</style>
